import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useSelector} from "react-redux";
import {Link, useHistory} from "react-router-dom";
import Footer from "../../../components/footer";

const Societies = (props) => {
    let history = useHistory();
    const society = useSelector(
        (state) => state.societies_module._get_all_societies
    );
    const [data, setData] = useState([]);

    useEffect(() => {
        if (society.data.datos) {
            setData(society.data.datos);
        }
    }, [society]);
    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);


    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);

        }
    }, [props]);


    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_societies').length > 0) {
                act.push({
                    name: "edit",
                    label: "Editar",
                    icon: "bx bx-edit",
                    color: "calendar",
                    onClick: (item) => {
                        history.push(`/sociedad/editar/${item.id}`);
                    },
                })

            }
        }
        setActions(act);
    }, [permisos, history]);

    return (
        <div className="app-content content">
            <div className="content-overlay"/>
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-3">
                        <Breadcrumbs
                            title="Sociedades"
                            items={[{label: "Sociedades", link: "/sociedades"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_societies').length > 0 ? <Link
                                        to="/sociedad/crear"
                                        className="btn btn-calendar"
                                    >
                                        Crear
                                    </Link> : null
                                }

                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "nombre",
                                                label: "Nombre",
                                                type: "text",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default Societies;
